export default __webpack_public_path__ + "static/media/copyLink.c0524fad.webp";